import { isAfter } from 'date-fns';
import useGate from 'hooks/useGate';
import { gateNames } from 'constants/statsig';
import useCheckAccess from 'hooks/useCheckAccess';

export const shouldShowAcknowledgementStatus = (record) => {
  const { value: isFacilityRateAcknowledgementGateOn } = useGate(
    gateNames.facilityRateAcknowledgement,
  );
  const checkAccess = useCheckAccess();
  const hasPermission = checkAccess('actions', 'Location', 'set_rate_structure');

  const isTen99Plan = record?.primary_billing_group?.plan === 'standard';
  const isInCalifornia = record?.state?.name === 'California';
  const rolloutDate = new Date('2025-08-06');
  const createdAfterRollout = isAfter(new Date(record?.created_at), rolloutDate);

  return (
    isTen99Plan &&
    isInCalifornia &&
    isFacilityRateAcknowledgementGateOn &&
    createdAfterRollout &&
    hasPermission
  );
};
